import { inject, Injectable } from "@angular/core";
import { EmployeeSecondingDialogComponent } from "./empoloyee-seconding-dialog/employee-seconding-dialog.component";
import { NbDialogService } from "@nebular/theme";
import { CareHomesService } from "../../shared/care-homes/care-homes.service";
import { BehaviorSubject } from "rxjs";
import { ICareHome } from "../shared/interfaces/care-home.interfaces";
import { FormBuilder, Validators } from "@angular/forms";
import { IDelegateEmployeeRequest } from "./employee.model";
import { EmployessService } from "../../shared/employess/employess.service";

@Injectable({ providedIn: "root" })
export class EmployeeSecondingService {
  dialog = inject(NbDialogService);
  careHomesService = inject(CareHomesService);
  employeeService = inject(EmployessService);
  fb = inject(FormBuilder);

  careHomesState = new BehaviorSubject<ICareHome[]>([]);

  createSecondingForm(
    isSend: boolean,
    careHomeId?: number,
    dateStart?: string,
    dateEnd?: string,
  ) {
    return this.fb.nonNullable.group({
      targetCareHomeId: this.fb.nonNullable.control(
        { value: careHomeId || null, disabled: !isSend },
        [Validators.required],
      ),
      comments: this.fb.nonNullable.control(""),
      dateStart: this.fb.nonNullable.control(
        { value: dateStart || null, disabled: !isSend },
        Validators.required,
      ),
      dateEnd: this.fb.nonNullable.control(
        { value: dateEnd || null, disabled: !isSend },
        [Validators.required],
      ),
    });
  }

  getCareHomes() {
    if (this.careHomesState.value.length === 0)
      this.careHomesService
        .getCareHomes()
        .subscribe((response: any) =>
          this.careHomesState.next(response.result.careHomesList),
        );
  }

  saveSeconding(employeeUid: string, body: IDelegateEmployeeRequest) {
    return this.employeeService.delegateEmployee(employeeUid, body);
  }

  openSecondingDialog(employeeUid: string) {
    return this.dialog.open(EmployeeSecondingDialogComponent, {
      context: {
        employeeUid,
        isSend: true,
        title: "Add multi-site working period",
      },
    }).onClose;
  }

  openCloseSecondingDialog(
    employeeUid: string,
    startData: { careHomeId?: number; dateStart?: string; dateEnd?: string },
  ) {
    return this.dialog.open(EmployeeSecondingDialogComponent, {
      context: {
        employeeUid,
        isSend: false,
        ...startData,
        title: "Cancel multi-site working period",
      },
    }).onClose;
  }
}
